export default [
  {
    path: '/offer/:offerId',
    name: 'offer',
    component: () => import(/* webpackChunkName: "offer" */ '@/views/Offer.vue'),
    props: true
  }
];
